import { render, staticRenderFns } from "./ShipmentAddPopup.vue?vue&type=template&id=db53b018&"
import script from "./ShipmentAddPopup.vue?vue&type=script&lang=js&"
export * from "./ShipmentAddPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports